/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrentInhibitionInfosPage } from '../models/current-inhibition-infos-page';
import { getCurrentInhibitions } from '../fn/alarms/get-current-inhibitions';
import { GetCurrentInhibitions$Params } from '../fn/alarms/get-current-inhibitions';


/**
 * All about alarms
 */
@Injectable({ providedIn: 'root' })
export class AlarmsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCurrentInhibitions()` */
  static readonly GetCurrentInhibitionsPath = '/custom/alarms/inhibitions/current';

  /**
   * Retrieve the on-going inhibition and maintenance alarms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentInhibitions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentInhibitions$Response(params?: GetCurrentInhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentInhibitionInfosPage>> {
    return getCurrentInhibitions(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the on-going inhibition and maintenance alarms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentInhibitions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentInhibitions(params?: GetCurrentInhibitions$Params, context?: HttpContext): Observable<CurrentInhibitionInfosPage> {
    return this.getCurrentInhibitions$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentInhibitionInfosPage>): CurrentInhibitionInfosPage => r.body)
    );
  }

}
